import { useLang } from "@/i18n/translations";

// CSS-only browser-style desktop frame. aspect 1920/1137 for real DealAlert screens.
export const DeviceFrameDesktop = ({ children, className = "", url = "", testId = "device-frame-desktop" }) => (
  <div data-testid={testId} className={`cs-frame-desktop ${className}`}>
    <div className="flex items-center gap-1.5 px-3.5 py-2.5 border-b border-white/5 bg-[#0d121b]">
      <span className="w-2.5 h-2.5 rounded-full bg-[#ff5f57]/70" />
      <span className="w-2.5 h-2.5 rounded-full bg-[#febc2e]/70" />
      <span className="w-2.5 h-2.5 rounded-full bg-[#28c840]/70" />
      {url && (
        <span className="ml-3 px-3 py-0.5 rounded-md bg-white/5 text-[10px] font-mono-cs text-muted-foreground/80 truncate max-w-[200px]">
          {url}
        </span>
      )}
    </div>
    <div className="relative">{children}</div>
  </div>
);

// CSS-only phone frame. Real DealAlert mobile screens are 840x1817 (~9:19.5).
export const DeviceFramePhone = ({ children, className = "", testId = "device-frame-phone" }) => (
  <div data-testid={testId} className={`cs-frame-phone ${className}`}>
    <div className="cs-frame-phone-inner">
      <div className="absolute top-2 left-1/2 -translate-x-1/2 w-[34%] h-[16px] bg-[#05070d] rounded-full z-10" />
      {children}
    </div>
  </div>
);

// Neutral placeholder: NO fake screenshots. Dashed frame + hatch + label.
export const PlaceholderMedia = ({ label, aspect = "16/9.5", className = "", testId = "placeholder-media" }) => {
  const { t } = useLang();
  return (
    <div
      data-testid={testId}
      className={`cs-placeholder rounded-lg flex items-center justify-center ${className}`}
      style={{ aspectRatio: aspect }}
      role="img"
      aria-label={label || t.wall.assetNeeded}
    >
      <span className="px-3 py-1.5 rounded-full border border-white/10 bg-[#05070d]/80 text-[11px] font-mono-cs text-muted-foreground tracking-wide">
        {label || t.wall.assetNeeded}
      </span>
    </div>
  );
};
